import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { GeneralLedgerPage } from '../../features/reports/general-ledger-page'
import { generalLedgerSearchSchema } from '../../features/reports/search'

export const Route = createFileRoute('/_app/general-ledger')({
  staticData: { crumb: 'generalLedger' },
  validateSearch: generalLedgerSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'reports.financial'),
  component: GeneralLedgerPage,
})
